<template>
    <div
        class="flex flex-col min-h-full col-span-1 text-center bg-white border divide-y divide-gray-200 shadow-sm rounded-t-2xl show-card">
        <div class="flex flex-col flex-1 px-8 py-6 ">
            <a :alt="talent.displayName" :href="`/talent/${talent.profileUrl}`" :title="talent.displayName" class="guide-img-container">
                <img :alt="talent.displayName" :src="talent.headShotUrl" :title="talent.displayName"
                    class="min-w-full mx-auto shrink-0 rounded-2xl">
                <h3 class="mt-6 font-medium text-gray-900 text-md">{{ talent.displayName }}</h3>
            </a>

            <dl class="flex flex-col justify-between flex-grow mt-1">
                <dt class="sr-only">{{ talent.displayName }}</dt>

                <dd v-if="talent.roles" class="mb-2 text-sm text-slate-600 line-clamp-2">{{ talent.roles.join(", ") }}
                </dd>

                <dd class="text-xs font-medium text-clay-600">
                    {{ talent.shortAddressPrettified }}
                </dd>
                <dt class="sr-only">Role</dt>
                <dd v-if="talent.vocalPart || talent.ageRange" class="mt-3">
                    <span v-if="talent.vocalPart"
                        class="inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100">{{
                        talent.vocalPart
                        }}</span>
                    <span v-if="talent.ageRange"
                        class="inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100">{{
                        talent.ageRange
                        }}</span>
                </dd>
            </dl>

            <div>
                <div class="flex justify-center pt-6 text-sm">
                    <Fanning :id="talent.id" :number-of-fans="talent.fanCount"></Fanning>
                    <Bookmarking :id="talent.id"></Bookmarking>
                </div>
            </div>

        </div>


    </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {TalentSearchProfileDTO} from "@/dtos";

const props = defineProps({
    talent: {},
})

const talent: TalentSearchProfileDTO = props.talent;

</script>
<style>

</style>